import http from "../../http-common";

const getAll = async () => {
  return await http
    .get("/admin/technicians/")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const update = async (data) => {
  return await http
    .put("/admin/technicians/", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const remove = async (platformId, technicianId) => {
  return await http
    .delete(`/admin/technicians/${platformId}/${technicianId}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll,
  update,
  remove,
};
